import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Typography, TextVariant } from '@components/shared/design/Typography';
import { PromoRibbon } from '@contracts';

interface Props {
  data: PromoRibbon;
  outerBackground: string;
}

const ProductPromoRibbon: React.FC<Props> = ({ data: { text, icon, borderColor, backgroundColor, textColor }, outerBackground }) => (
  <Container $background={backgroundColor} $outerBackground={outerBackground} $border={borderColor}>
    {icon && (
      <GatsbyImage image={icon.gatsbyImageData} alt={icon.alt ?? 'product ribbon icon'} objectFit="contain" style={{ minWidth: 20, minHeight: 20 }} />
    )}
    <Typography $variant={TextVariant.BodyRegularSM} $textColor={textColor}>
      {text}
    </Typography>
  </Container>
);

export default ProductPromoRibbon;

interface StyleProps {
  $border?: string;
  $background?: string;
  $textColor?: string;
  $outerBackground?: string;
}

const Container = styled.div<StyleProps>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  gap: 5px;
  padding: 4px 36px;
  border-color: ${({ $border }) => $border ?? 'transparent'};
  border-width: 1px;
  border-style: solid;
  background: ${({ $background }) => $background ?? 'linear-gradient(90deg, #DBE8F1 0%, #FAEEEB 100%);'};

  @media (max-width: 1024px) {
    align-self: center;
  }
`;
